import {Injectable, ViewContainerRef} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {finalize} from 'rxjs/operators';

import {MP_RESULT, MpConfig} from '../../components/msg-popup/msg-popup.component';
import {SimpleWord} from '../../models/simple-word.model';
import {PushInfo} from "../fcm/fcm.service";
import {ExampleSJ, LinkedExample, Word} from '../../models/word.model';

@Injectable({
  providedIn: 'root'
})
export class LayoutMgrService {
  public showMenu     = false;
  public showBookmark = false;
  public showPitch    = false;
  public showExample  = false;
  public showHelp     = false;
  public showExampleHelp = false;
  public showPitchHelp= false;
  public showIndex    = false;
  public cordovaYoutubeBg = false;

  // msg-popup 관련
  public showMsgPopup = false;
  public mpConfig: MpConfig = null;
  // public mpConfig: MpConfig = {
  //   msg: '테스트 팝업 본문',
  //   title: '테스트 제목',
  //   image: 'assets/img/ic_popup_error.svg',
  //   btnOk: '확인',
  // };
  public msgPopup$: Subject<MP_RESULT>;

  // noti-popup 관련
  public showNotiPopup = false;
  public pushInfo: PushInfo = null;

  // pitch popup 관련
  public wordPitch: SimpleWord | Word | null = null;

  // example popup 관련
  public exampleSJ: ExampleSJ | null = null;

  // linked-example popup 관련
  public showLinkedExample = false;
  public linkedExample: LinkedExample | null = null;

  public vcRef: ViewContainerRef;

  constructor() { }

  public Reset(): void {
    this.showMenu     = false;
    this.showBookmark = false;
    this.showPitch    = false;
    this.showExample = false;
    this.showHelp     = false;
    this.showExampleHelp = false;
    this.showPitchHelp = false;
    this.showIndex    = false;
    this.showLinkedExample = false;
  }

  public get PaddingClass(): string {
    return this.showIndex ? 'page-keyword' : 'page-keyword2';
  }

  // msg-popup 관련
  public OpenMsgPopup(config: MpConfig): Observable<MP_RESULT> {
    this.showMsgPopup = true;
    this.mpConfig = config;
    this.msgPopup$ = new Subject<MP_RESULT>();
    this.msgPopup$.subscribe({
      complete: () => {
        // console.log('OpenMsgPopup::finalize()', this);
        this.showMsgPopup = false;
      }
    });
    return this.msgPopup$.asObservable();
  }

  public OpenMsgPopupAlert(msg: string, title: string = '오류'): Observable<any> {
    return this.OpenMsgPopup({
      title,
      msg,
      btnError: '확인',
    });
  }

  public onClickMsgBtn(mpResult: MP_RESULT): void {
    // console.log('lm::onClickMsgBtn()');
    this.msgPopup$.next(mpResult);
    this.msgPopup$.complete();
  }

  public OpenNotiPopup(pushInfo: PushInfo): void {
    this.pushInfo = pushInfo;
    this.showNotiPopup = true;
  }

  public CloseNotiPopup(): void {
    this.pushInfo = null;
    this.showNotiPopup = false;
  }

  public OpenPitchPopup(word: SimpleWord): void {
    this.wordPitch = word;
    this.showPitch = true;
  }

  public ClosePitchPopup(): void {
    this.wordPitch = null;
    this.showPitch = false;
  }

  public OpenExamplePopup(word: Word, exampleSJ: ExampleSJ): void {
    this.wordPitch = word;
    this.exampleSJ = exampleSJ;
    this.showExample = true;
  }

  public CloseExamplePopup(): void {
    this.exampleSJ = null;
    this.showExample = false;
  }

  public OpenLinkedExamplePopup(example: LinkedExample): void {
    this.linkedExample = example;
    this.showLinkedExample = true;
  }

  public CloseLinkedExamplePopup(): void {
    this.showLinkedExample = false;
    this.linkedExample = null;
  }

  /****************************************************************************
   * 네이버 로그인 관련
   ****************************************************************************/
  public naverLoginPopup$: Subject<string|null> | null = null;

  public get showNaverLogin(): boolean {
    return this.naverLoginPopup$ !== null;
  }

  public OpenNaverLoginPopup(): Observable<string|null> {
    this.naverLoginPopup$ = new Subject<string|null>();
    return this.naverLoginPopup$.pipe(
      finalize(() => {
        this.naverLoginPopup$ = null;
      }),
    );
  }


  /****************************************************************************
   * 웹용 유튜브 플레이어
   ****************************************************************************/
  public youtubeId: string | null = null;
  public youtubePopup$: Subject<string | null> | null = null;

  public OpenYoutubePopup(youtubeId: string): Observable<string | null> {
    this.youtubeId = youtubeId;
    this.youtubePopup$ = new Subject<string | null>();
    return this.youtubePopup$.pipe(
      finalize(() => {
        this.youtubeId = null;
        this.youtubePopup$ = null;
      })
    );
  }

  public CloseYoutubePopup(): void {
    console.warn('LayoutMgrService::closeYoutubePopup()');
    if (this.youtubePopup$) {
      this.youtubePopup$.next(null);
      this.youtubePopup$.complete();
    }
    this.youtubeId = null;
  }
}
